<template>
  <div class="fields-feature-section">
    <div class="main-container">
      <feature5
        v-for="feature in fields.field_one.value.boxes"
        :key="feature.title"
        :feature="feature"
      />
    </div>
  </div>
</template>

<script>
import Feature5 from "/seu-frontend/components/section-fields/Feature5";

export default {
  name: 'FieldsFeatureSection',
  components: {Feature5},
  props: {
    fields: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
@import "FieldsFeatureSection";
</style>
